module.exports = __webpack_public_path__ + "img/grey.619d5843.png";